(function () {
  var pending;
  var assignedSlot;
  var nextSlotKey = 'kronkMobileWidgetNextSlot';

  function isMobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function isProductPage() {
    return document.body && document.body.classList.contains('template-product');
  }

  function shouldAlternateWidgets() {
    return document.body && isMobile() && !isProductPage();
  }

  function getNextSlot() {
    var nextSlot = 'google';

    try {
      nextSlot = window.sessionStorage.getItem(nextSlotKey) || nextSlot;
      window.sessionStorage.setItem(nextSlotKey, nextSlot === 'google' ? 'email' : 'google');
    } catch (error) {
      nextSlot = 'google';
    }

    return nextSlot === 'email' ? 'email' : 'google';
  }

  function assignSlot() {
    if (!shouldAlternateWidgets()) {
      assignedSlot = null;
      return;
    }

    if (!assignedSlot) {
      assignedSlot = getNextSlot();
    }
  }

  function syncWidgetState() {
    if (!document.body) {
      return;
    }

    document.querySelectorAll('.kronk-email-teaser, #kronk-email-incentive-placement').forEach(function (element) {
      element.remove();
    });

    assignSlot();

    document.body.classList.toggle('kronk-widget-slot-google', assignedSlot === 'google');
    document.body.classList.toggle('kronk-widget-slot-email', assignedSlot === 'email');

    var google = document.getElementById('google-merchantwidget-iframe-wrapper');

    if (!google) {
      return;
    }

    if (!google.hasAttribute('data-kronk-original-bottom')) {
      google.setAttribute('data-kronk-original-bottom', google.style.getPropertyValue('bottom'));
      google.setAttribute('data-kronk-original-bottom-priority', google.style.getPropertyPriority('bottom'));
      google.setAttribute('data-kronk-original-left', google.style.getPropertyValue('left'));
      google.setAttribute('data-kronk-original-left-priority', google.style.getPropertyPriority('left'));
    }

    google.style.setProperty(
      'bottom',
      google.getAttribute('data-kronk-original-bottom') || '20px',
      google.getAttribute('data-kronk-original-bottom-priority') || 'important'
    );
    google.style.setProperty(
      'left',
      google.getAttribute('data-kronk-original-left') || '0px',
      google.getAttribute('data-kronk-original-left-priority') || 'important'
    );
  }

  function scheduleSync() {
    window.clearTimeout(pending);
    pending = window.setTimeout(syncWidgetState, 100);
  }

  document.addEventListener('DOMContentLoaded', syncWidgetState);
  window.addEventListener('load', syncWidgetState);
  window.addEventListener('resize', scheduleSync);

  new MutationObserver(scheduleSync).observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['class', 'style'],
    childList: true,
    subtree: true
  });
})();
